<template>
  <div v-if="isVisible" class="global-spinner-overlay">
    <div class="spinner-container">
      <div class="animated-bar-chart">
        <div class="bar bar-1"></div>
        <div class="bar bar-2"></div>
        <div class="bar bar-3"></div>
        <div class="bar bar-4"></div>
        <div class="bar bar-5"></div>
      </div>
      <div class="spinner-text">{{ message }}</div>
      <div v-if="subMessage" class="spinner-sub-text">{{ subMessage }}</div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useGlobalSpinner } from '@/composables/useGlobalSpinner'

const { isVisible, message, subMessage } = useGlobalSpinner()
</script>

<style scoped>
.global-spinner-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(2px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  animation: fadeIn 0.3s ease-in-out;
}

.spinner-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
}

.animated-bar-chart {
  display: flex;
  align-items: flex-end;
  gap: 0.5rem;
  height: 60px;
}

.bar {
  width: 12px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 6px 6px 2px 2px;
  animation: barAnimation 1.5s ease-in-out infinite;
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
}

.bar-1 {
  animation-delay: 0s;
}

.bar-2 {
  animation-delay: 0.1s;
}

.bar-3 {
  animation-delay: 0.2s;
}

.bar-4 {
  animation-delay: 0.3s;
}

.bar-5 {
  animation-delay: 0.4s;
}

@keyframes barAnimation {
  0%, 100% {
    height: 20px;
    opacity: 0.6;
  }
  50% {
    height: 60px;
    opacity: 1;
  }
}

.spinner-text {
  font-size: 1.2rem;
  font-weight: 600;
  color: #2d3748;
  text-align: center;
}

.spinner-sub-text {
  font-size: 0.9rem;
  color: #718096;
  text-align: center;
  max-width: 300px;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .animated-bar-chart {
    height: 50px;
    gap: 0.4rem;
  }
  
  .bar {
    width: 10px;
  }
  
  @keyframes barAnimation {
    0%, 100% {
      height: 15px;
      opacity: 0.6;
    }
    50% {
      height: 50px;
      opacity: 1;
    }
  }
  
  .spinner-text {
    font-size: 1.1rem;
  }
  
  .spinner-sub-text {
    font-size: 0.85rem;
  }
}
</style>